import { mergeStyles, Stack, Text } from '@fluentui/react';

import ContentBox from '../../ContentBox';
import FormList from './FormList';

export default () => {
  return (
    <Stack tokens={{ childrenGap: 10 }} className={styles}>
      <Text variant="xxLarge">Son Formlar</Text>
      <ContentBox>
        <FormList />
      </ContentBox>
    </Stack>
  );
};

const styles = mergeStyles({
  width: "90%",
  marginLeft: "5%",
  marginTop: "8px",
});
